import { ResourceView } from "@ra-data-prisma/dataprovider";
import { gql } from "@apollo/client";

const UserFragment = gql`
  fragment UserFragment on User {
    id
    carloUsername
    companies {
      id
    }
    createdAt
    deliveryNotesVisitor
    email
    firstName
    lastName
    ingresUsername
    isAd
    isAdmin
    presetPassword
    selectedCompany {
      id
    }
    selectedCompanyId
    userDefaultValues {
      id
      property
      value
    }
  }
`;

export const UserResource: ResourceView = {
  resource: "User",
  fragment: {
    one: {
      type: "document",
      mode: "replace",
      doc: UserFragment,
    },
    many: {
      type: "document",
      mode: "replace",
      doc: UserFragment,
    },
  },
};
